import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BasicTenderInfo from "../../Users/BriefTender/BasicTenderInfo";
import Preview from "./Preview";
import AddRebid from "./AddRebid";

const RebidSubmission = () => {
  const [tender, setTender] = useState();
  const [workItems, setWorkItems] = useState();
  const [step, setStep] = useState(1);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const { tenderId } = useParams();

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setTender(res.data);
        setWorkItems(res.data.workItemDetails);
        if (res.data.isSingleBid) {
          setStep(2);
        }
      } catch (error) {
        console.error(error);
      }
    };
    getTender();
  }, []);
  return (
    <div>
      {tender && (
        <div>
          <BasicTenderInfo tender={tender} />
          {step === 1 && (
            <AddRebid
              tender={tender}
              data={workItems}
              setData={setWorkItems}
              setStep={setStep}
              user={storedUser}
            />
          )}
          {step === 2 && (
            <Preview
              tender={tender}
              setStep={setStep}
              data={workItems}
              user={storedUser}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default RebidSubmission;
